import { Divider, Flex, Text } from '@/components';
import type { ReactNode } from 'react';

export const SectionTitle = ({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) => {
  return (
    <Flex style={{ padding: '12px 0 16px' }} align="center">
      <Text variant="h3" text={title} />

      {children ? (
        <Flex align="center">
          <Divider type="vertical" size="sm" style={{ height: 16 }} />
          <div>{children}</div>
        </Flex>
      ) : null}
    </Flex>
  );
};
